module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lightest radius-normal border-light d-flex flex-wrap text-center mt-2 py-2"
  }, _vm._l((_vm.bookingGenderPrices), function(personPrice, index) {
    return (_vm.getAudienceTypeList && (personPrice.genderPriceType == 2 || personPrice.genderPriceType == 1 && personPrice.isExcludedFromBilling)) ? _c('div', {
      staticClass: "col-sm-4 pt-2 pb-2"
    }, [_c('div', {
      staticClass: "font-weight-600"
    }, [_vm._v(_vm._s(_vm.genderPriceName(personPrice)))]), _vm._v(" "), _c('div', {
      staticClass: "medium"
    }, [_vm._v(_vm._s(_vm.genderPriceDescription(personPrice)))]), _vm._v(" "), (_vm.reservation.bookingGenderPrices[0].genderPriceType == 2) ? _c('div', {
      staticClass: "dark"
    }, [_vm._v(_vm._s(_vm.formatPrice(_vm.showTicketPrice(personPrice))) + " €")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mt-2"
    }, [_c('button', {
      staticClass: "btn fs-largest bg-lightest dark border-medium py-1 px-3 h-100",
      attrs: {
        "disabled": _vm.readOnly
      },
      on: {
        "click": function($event) {
          return _vm.subtractPerson(personPrice)
        }
      }
    }, [_vm._v(" - ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (personPrice.quantityToBook),
        expression: "personPrice.quantityToBook",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "text-center fs-largest darker bg-lighter border-medium radius-normal py-1 px-1 mx-2",
      staticStyle: {
        "width": "3rem"
      },
      attrs: {
        "type": "number",
        "disabled": _vm.readOnly,
        "value": "0"
      },
      domProps: {
        "value": (personPrice.quantityToBook)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(personPrice, "quantityToBook", _vm._n($event.target.value))
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
          return _vm.paxManuallyChanged(personPrice)
        }],
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn fs-largest bg-lightest dark border-medium py-1 px-3 h-100",
      attrs: {
        "disabled": _vm.readOnly
      },
      on: {
        "click": function($event) {
          return _vm.addPerson(personPrice)
        }
      }
    }, [_vm._v(" + ")])])]) : _vm._e()
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5053b1ab", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5053b1ab"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Details/PersonTicketSelector.vue
// module id = 1780
// module chunks = 0